export type CountryOption = {
  value: string;
  label: string;
};

type BuildCountryOptionsResult = {
  options: CountryOption[];
  defaultValue?: string;
};

export function buildCountryOptions(
  countries: readonly CountryOption[],
  initialCountry?: string | null,
): BuildCountryOptionsResult {
  const base = countries.map((country) => ({
    value: country.value,
    label: country.label,
  }));

  const trimmed = initialCountry?.trim();
  if (!trimmed) {
    return { options: base, defaultValue: base[0]?.value };
  }

  const match =
    base.find((c) => c.value.toLowerCase() === trimmed.toLowerCase()) ??
    base.find((c) => c.label.toLowerCase() === trimmed.toLowerCase());

  if (match) {
    return { options: base, defaultValue: match.value };
  }

  const custom = { value: trimmed, label: trimmed };
  return { options: [...base, custom], defaultValue: custom.value };
}

export function getCountryLabel(
  countries: readonly CountryOption[],
  value?: string | null,
): string | null {
  const trimmed = value?.trim();
  if (!trimmed) return null;

  const match =
    countries.find(
      (country) => country.value.toLowerCase() === trimmed.toLowerCase(),
    ) ??
    countries.find(
      (country) => country.label.toLowerCase() === trimmed.toLowerCase(),
    );

  return match?.label ?? trimmed;
}

export function isUnitedStatesCountry(value?: string | null): boolean {
  const normalized = value?.trim().toLowerCase();
  return (
    normalized === 'us' ||
    normalized === 'usa' ||
    normalized === 'united states' ||
    normalized === 'united states of america'
  );
}
